import {createFeatureSelector, createSelector} from "@ngrx/store";
import {Revisione53State, STATE_KEY_REVISIONE53} from "../revisione53.reducers";

const coreState = createFeatureSelector<Revisione53State>(STATE_KEY_REVISIONE53)

export abstract class revisione53DatiSecondariSelectors {

  static getAbLocaliRappresentanti = createSelector(
    coreState,
    state => state.revisione.datiSecondari.aB_LegaliRappresentanti
  )

  static getAbLocaleRappresentante = (idAssegnazione: string) => createSelector(
    coreState,
    state => state.revisione.datiSecondari.aB_LegaliRappresentanti.find(legale => legale.id_assegnazione === idAssegnazione)
  )

  static getAEIncaricoSoci = (idAssegnazione: string) => createSelector(
    coreState,
    state => {
      const incarico = state.revisione.datiSecondari.aE_Incarico.find(incarico => incarico.id_assegnazione === idAssegnazione);
      return [
        {
          sociFisiciCooperatori: incarico?.sociFisiciCooperatori_1,
          sociGiuridiciCooperatori: incarico?.sociGiuridiciCooperatori_1,
          sociFisiciFinanziatori:	incarico?.sociFisiciFinanziatori_1,
          sociGiuridiciFinanziatori: incarico?.sociGiuridiciFinanziatori_1,
          sociSpeciali:	incarico?.sociSpeciali_1,
          dataSoci: incarico?.dataSoci_1,
        },
        {
          sociFisiciCooperatori: incarico?.sociFisiciCooperatori_2,
          sociGiuridiciCooperatori: incarico?.sociGiuridiciCooperatori_2,
          sociFisiciFinanziatori:	incarico?.sociFisiciFinanziatori_2,
          sociGiuridiciFinanziatori: incarico?.sociGiuridiciFinanziatori_2,
          sociSpeciali:	incarico?.sociSpeciali_2,
          dataSoci: incarico?.dataSoci_2,
        },
        {
          sociFisiciCooperatori: incarico?.sociFisiciCooperatori_3,
          sociGiuridiciCooperatori: incarico?.sociGiuridiciCooperatori_3,
          sociFisiciFinanziatori:	incarico?.sociFisiciFinanziatori_3,
          sociGiuridiciFinanziatori: incarico?.sociGiuridiciFinanziatori_3,
          sociSpeciali:	incarico?.sociSpeciali_3,
          dataSoci: incarico?.dataSoci_3,
        },
      ]
    }
  )

  static getAEIncaricoLav = (idAssegnazione: string) => createSelector(
    coreState,
    state => {
      const incarico = state.revisione.datiSecondari.aE_Incarico.find(incarico => incarico.id_assegnazione === idAssegnazione);
      return [
        {
          UnitaSociUtil: incarico?.lavSoci_1,
          UnitaNonSociUtil: incarico?.lavNonSoci_1,
          NumLavSub:	incarico?.lavSubIndeterminato_1,
          NumLavSubTempoDeterminato: incarico?.lavSubDeterminato_1,
          NumLavParaSub:	incarico?.lavParaSub_1,
          NumLavAut: incarico?.lavAutonomo_1,
          NumLavAltro:	incarico?.lavAltro_1,
          dataLav: incarico?.dataLav_1,
        },
        {
          UnitaSociUtil: incarico?.lavSoci_2,
          UnitaNonSociUtil: incarico?.lavNonSoci_2,
          NumLavSub:	incarico?.lavSubIndeterminato_2,
          NumLavSubTempoDeterminato: incarico?.lavSubDeterminato_2,
          NumLavParaSub:	incarico?.lavParaSub_2,
          NumLavAut: incarico?.lavAutonomo_2,
          NumLavAltro:	incarico?.lavAltro_2,
          dataLav: incarico?.dataLav_2,
        },
        {
          UnitaSociUtil: incarico?.lavSoci_3,
          UnitaNonSociUtil: incarico?.lavNonSoci_3,
          NumLavSub:	incarico?.lavSubIndeterminato_3,
          NumLavSubTempoDeterminato: incarico?.lavSubDeterminato_3,
          NumLavParaSub:	incarico?.lavParaSub_3,
          NumLavAut: incarico?.lavAutonomo_3,
          NumLavAltro:	incarico?.lavAltro_3,
          dataLav: incarico?.dataLav_3,
        },
      ]
    }
  )

  static getAEIncarico = createSelector(
    coreState,
    state => state.revisione.datiSecondari.aE_Incarico
  )

}
